import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {ApiGridSearch} from '@assets/js/api/commonApi.js';

const CompGridCmptnAllow = forwardRef((props, ref) => {
    // Forward ref to allow parent components to call event functions.
    useImperativeHandle(ref, () => ({
        onGridSearch: (p_params) => {
            onGridSearch(p_params);
        },
    }));

    /**********************
     * Define Grid variable
    ***********************/
    // State for grid pagination and loading
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });

    // Define columns for DataGrid
    const columns = [
        { field: 'rowNum', headerName: 'No.', width: 65, headerAlign: 'center', align: 'center' },
        { field: 'userId', headerName: '사용자ID', width: 150, headerAlign: 'center', align: 'left' },
        { field: 'userNm', headerName: '사용자명', width: 150, headerAlign: 'center', align: 'left' },
        { field: 'cmptnAllowYnNm', headerName: '승인상태', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'reqDate', headerName: '요청일시', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'allowDate', headerName: '승인일시', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'userPsNm', headerName: '직함', width: 120, headerAlign: 'center', align: 'center' },
        { field: 'email', headerName: '이메일', width: 200, headerAlign: 'center', align: 'left' },
        { field: 'telno', headerName: '전화번호', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'hostOrgNm', headerName: '지부명(팀명)', width: 150, headerAlign: 'center', align: 'left' },
    ];

    /*********************
     * Define Grid events
    ***********************/
    const onGridSearch = (p_params) => {
        let params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            offset: paginationModel.page * paginationModel.pageSize,
            ...p_params
        }

        // <-- loading start
        setLoading(true);
        // Fetch data from the server
        ApiGridSearch('/adm/cmptnallow/search/list', params)
        .then(res => {
            if (res.data && res.data.result) {
                const rows = res.data.dataList.length > 0 ? res.data.dataList : [];
                const totalCount = res.data.dataList.length > 0 ? res.data.dataList[0].totalCount : 0;
                setRows(rows);
                setTotalRowCount(totalCount);
            }
            setRowSelectionModel({ type: 'include', ids: new Set() });
        })
        .catch(error => {
            console.error('Error fetching cmptn allow list:', error);
        })
        .finally(() => {
            // <-- loading end
            setLoading(false);
        });
    }

    /**********************
     * Define useEffect
    ***********************/
    useEffect(() => {
        onGridSearch();
        // eslint-disable-next-line
    }, [paginationModel]);

    return (
        <>
            <div className="grid-container">
                <h4>외부대회허용 신청 목록</h4>
            </div>
            <div className="grid-wrapper">
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.userId}
                    loading={loading}
                    pageSizeOptions={[100, 200, 500]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    paginationMode="server"
                    rowCount={totalRowCount}
                    checkboxSelection
                    rowSelectionModel={rowSelectionModel}
                    onRowSelectionModelChange={(newSelection) => {
                        const arraySelections = [...newSelection.ids];
                        if (props.onSelectionChange) {
                            const selectedRowData = arraySelections.map(id => {
                                return rows.find(row => row.userId === id);
                            });

                            setRowSelectionModel(newSelection);
                            props.onSelectionChange({ ids: newSelection.ids, data: selectedRowData });
                        }
                    }}
                    keepNonExistentRowsSelected
                />
            </div>
        </>
    );
});

export default CompGridCmptnAllow;
